import React from "react";
import { GenericDialog } from "../../components/generic/GenericDialog";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Sparkle } from "@phosphor-icons/react";

export const BroadcastMessageDialog = (props) => {
  const {
    openCollabRequestUpdateDialog,
    handleCloseRequestUpdateDialog,
    broadcastMessageDetails,
  } = props;

  const paragraphs = broadcastMessageDetails?.meta?.broadcast_message?.split("\n").filter(line => line.trim() !== "") || [];
  return (
    <GenericDialog
      width={'729px'}
      title={broadcastMessageDetails?.title}
      openDialog={openCollabRequestUpdateDialog}
      handleClose={handleCloseRequestUpdateDialog}
    >
      <Box sx={{ p: 3 }}>
        <Stack alignItems="center" gap={2} mb={3}>
          <Box
            color={'primary.main'}
            sx={{
              backgroundColor: 'background.lightBlue',
              borderRadius: "50%",
              width: 128,
              height: 128,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Sparkle size={96} weight='thin' />
          </Box>
          <Typography
            variant="h6"
            fontWeight={700}
            textAlign="center"
          >
            {broadcastMessageDetails?.meta?.broadcast_title}
          </Typography>
        </Stack>

        {paragraphs.map((paragraph, index) => (
          <Box key={index} sx={{ whiteSpace: 'normal', p: 0 }} className="ql-editor">
            <Typography 
              variant="body1" 
              mb={2}
              dangerouslySetInnerHTML={{ __html: paragraph }}
            />
          </Box>
        ))}

        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} mt={2}>
          <Button
            size="large"
            variant="contained"
            className="longButton"
            onClick={() => handleCloseRequestUpdateDialog()}
          >
            Got it!
          </Button>
        </Box>
      </Box>
    </GenericDialog>
  );
};